import { render } from "./UiLockAnimation.vue?vue&type=template&id=15588aa4&scoped=true"
import script from "./UiLockAnimation.vue?vue&type=script&lang=js"
export * from "./UiLockAnimation.vue?vue&type=script&lang=js"

import "./UiLockAnimation.vue?vue&type=style&index=0&id=15588aa4&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15588aa4"]])

export default __exports__